import { Incasso } from './incasso';
import { SoggettoPratica } from './tipologiche/soggetto-pratica';

export class IncassoSoggetto {
    id: string;
    incasso: Incasso;
    soggetto: SoggettoPratica;
    percentualeIncasso: number;
}
